import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'software_products/redux/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
